<div class="hidden-md hidden-lg">
  <app-nav></app-nav>
</div>
<div class="visible-lg visible-md">
  <app-headermain></app-headermain>
</div>

@if (route(); as r) {
  <main class="fr-shell">
    <app-flight-route-hero [route]="r" />

    <div class="buupass-container">
      <section class="fr-search" [id]="searchId" [attr.aria-label]="'Search ' + r.from.city + ' to ' + r.to.city + ' flights'">
        <app-flight-search-bar variant="hero" [prefill]="prefill()"></app-flight-search-bar>
      </section>
    </div>

    <app-flight-route-body [route]="r" [related]="related()" />
  </main>
}

<app-footer></app-footer>
